<div class="input-main-container ym-display-flex ym-flex-direction-column ym-gap-2" [class.error-occured]="error">
    <div class="label-container ym-display-flex ym-align-items-center ym-gap-3" *ngIf="showLabel">
        <div class="ym-text-color ym-display-flex ym-align-items-center ym-gap-2 ym-w-full">
            <span class="text ym-font-base ym-line-height-normal">{{label}}</span>
            <span class="optional-indicator ym-text-secondary ym-display-inline-block" *ngIf="!required && !hideOptional">
                <!-- <span class="icon ym-svg-sm ym-mt-n2">
                    <ym-icon [iconName]="iconNames.REQUIRED"></ym-icon>
                </span> -->
                (optional)
            </span>
            <span class="inline-info ym-svg-base" *ngIf="inlineInfo">
                <ym-inline-info [hideTooltip]="true">
                    {{inlineInfo}}
                </ym-inline-info>
            </span>
        </div>
    </div>
    <ym-button [disabled]="disabled" [fullWidth]="true" [icon]="iconNames.CALENDAR"
        [variant]="buttonVariants.ICON_TEXT_AND_DROPDOWN" [ymPopoverTrigger]="popover"
        [ymPopoverPosition]="popoverPositions.BELOW_LEFT_START" [ymPopoverOpen]="isDropdownOpen"
        (onPopoverClose)="toggleDropdown(false)" (onClick)="toggleDropdown(true)" class="ym-w-full">
        {{dateValue?(dateValue | dateTime : dateTimeFormats.LONG): ''}}
    </ym-button>
    <span class="error-text ym-font-sm ym-text-danger ym-display-block ym-line-height-normal"
        *ngIf="error">{{errorText}}</span>
</div>

<ng-template #popover>
    <div class="dropdown-main ym-display-flex ym-flex-direction-column ym-p-5 ym-gap-5">
        <div class="ym-display-flex ym-flex-direction-column ym-gap-2">
            <div class="label-container ym-display-flex ym-align-items-center ym-gap-3">
                <div class="ym-text-color ym-display-flex ym-align-items-center ym-gap-2 ym-w-full">
                    <span class="text ym-font-base ym-line-height-normal">{{label}}</span>
                    <span class="required-indicator ym-text-red-300 ym-md-display-inline-block" *ngIf="required">
                        <span class="icon ym-svg-sm ym-mt-n2">
                            <ym-icon [iconName]="iconNames.REQUIRED"></ym-icon>
                        </span>
                    </span>
                    <span class="inline-info ym-svg-base" *ngIf="inlineInfo">
                        <ym-inline-info [hideTooltip]="true">
                            {{inlineInfo}}
                        </ym-inline-info>
                    </span>
                </div>
            </div>
            <div class="content ym-display-flex ym-gap-3">
                <ym-date-input [showCalendarClearDate]="false" [showLabel]="false" [value]="popupDateValue"
                    (valueChange)="updateDateValue($event)" class="ym-w-full"></ym-date-input>
                <ym-time-input [showLabel]="false" [value]="popupDateValue" (valueChange)="updateTimeValue($event)"
                    class="ym-w-full"></ym-time-input>
            </div>
        </div>

        <div class="actions ym-display-flex ym-gap-3 ym-justify-content-space-between">
            <ym-button [type]="buttonTypes.DEFAULT" (onClick)="clearField()">Clear</ym-button>
            <span class="ym-display-flex ym-gap-3">
                <ym-button [type]="buttonTypes.GHOST" (onClick)="cancelPopup()">Cancel</ym-button>
                <ym-button [type]="buttonTypes.PRIMARY" (onClick)="savePopup()">Save</ym-button>
            </span>
        </div>
    </div>
</ng-template>